import { AxiosResponse } from 'axios';
import { CatalogMeasure } from '../../../types/CatalogMeasure';
import { CatalogMeasuresDto } from '../../../types/dto/CatalogMeasuresDto';

const mapCatalogMeasureDtoToCatalogMeasure = ({ data }: AxiosResponse<CatalogMeasuresDto>): CatalogMeasure[] => data.value
  .filter(({ Active }) => Active)
  .map(({ MeasureID, MeasureName }) => ({ id: MeasureID, name: MeasureName }));

export default mapCatalogMeasureDtoToCatalogMeasure;
